// crm-web/frontend/src/store/useAnalyticsStore.js
// Estado compartido entre tabs del dashboard de analiticas.
// selectedAgentId: filtra Clasificacion a un agente (deep-link desde scorecard).

import { create } from 'zustand'

const STORAGE_KEY_EXCLUDE_ADMIN = 'analytics_exclude_admin'

function getInitialExcludeAdmin() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY_EXCLUDE_ADMIN)
    // Default: true (ocultar admin agents). Explicit 'false' para mostrarlos.
    if (saved === 'false') return false
    return true
  } catch { return true }
}

const useAnalyticsStore = create((set) => ({
  selectedAgentId: null,
  pendingTabId: null,
  excludeAdminAgents: getInitialExcludeAdmin(),
  setSelectedAgentId: (id) => set({ selectedAgentId: id }),
  goToClassificationForAgent: (agentId) => set({ selectedAgentId: agentId, pendingTabId: 'classification' }),
  clearSelectedAgent: () => set({ selectedAgentId: null }),
  acknowledgePendingTab: () => set({ pendingTabId: null }),
  setExcludeAdminAgents: (exclude) => {
    try { localStorage.setItem(STORAGE_KEY_EXCLUDE_ADMIN, exclude ? 'true' : 'false') } catch {}
    set({ excludeAdminAgents: exclude })
  },
}))

export default useAnalyticsStore
